import type { FC } from 'react';

import { SectionBrandmanager } from '../../components/section-brandmanager/section-brandmanager';
import { SectionCompaniesByIndustries } from '../../components/section-companies-by-industry/section-companies-by-industry';
import { SectionCompaniesInsights } from '../../components/section-companies-insights/section-companies-insights';
import { SectionRecommendedCompanies } from '../../components/section-recommended-companies/section-recommended-companies';

import * as Styled from './logged-in-landing-page.styles';

export const LoggedInLandingPage: FC = () => {
  return (
    <Styled.Wrapper data-testid="LOGGED-IN-LANDING-PAGE">
      <SectionBrandmanager />
      <SectionRecommendedCompanies />
      <SectionCompaniesInsights />
      <SectionCompaniesByIndustries />
    </Styled.Wrapper>
  );
};
